export default __webpack_public_path__ + "static/media/ad-van-1000px.0da47b5a.jpg";